module.exports = __webpack_public_path__ + "img/sidebar-logo-expanded.1525075b.png";